import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAppDispatch } from "../../../shared/hooks/sharedHooks";
import { ServiceReport } from "../models/ServiceReportsModel";
import { setSuccess } from "../customerMachinerySlice";
import useTranslation from "../../../shared/hooks/useTranslation";

export interface ServiceReportShareDialogProps {
  open: boolean;
  serviceReport: ServiceReport;
  onClose?: () => void;
}

const ServiceReportShareDialog = ({ open, serviceReport, onClose }: ServiceReportShareDialogProps) => {
  const dispatch = useAppDispatch();
  const { translate } = useTranslation("myMachinery");
  const { translate: tCommon } = useTranslation("common");

  const serviceReportUrl = `${window.location.origin}/public/service-reports/${serviceReport.number}`;

  const handleCopyLink = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(serviceReportUrl);
      dispatch(setSuccess(translate("linkCopied")))
      onClose?.();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        <Box component="p" className="heading-2">{translate("shareLink")}</Box>
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 14,
          top: 14,
          color: "#333333"
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <TextField defaultValue={serviceReportUrl} disabled fullWidth />
      </DialogContent>

      <DialogActions className="flex mt-2">
        <Button variant="text" className="w-full" onClick={onClose}>
          {tCommon("buttons.close")}
        </Button>

        <Button variant="contained" className="w-full" onClick={handleCopyLink}>
          {translate("copyLink")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceReportShareDialog;